import React, { Component } from "react"
import Svg from "../_svgs/svg"
import { DateTime } from "luxon"
import * as date from "../../booking/helpers/date"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { trackTravelPlannerInteraction } from "../../helpers/tracking"

export class ItineraryArrivalDeparture extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      awaitingClosedLabel: props.awaitingClosedLabel,
      hidePastSteps: props.hidePastSteps,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
    this.handleClickTracking = this.props.handleClickTracking.bind(this)

    this.arrivalDepartureRef = React.createRef()
  }

  componentDidMount() {
    var hash = window.location.hash
    if (hash) {
      if (hash === "#on-time" || hash === "#estimated-arrival" || hash === "#estimated-departure" || hash === "#landed") {
        this.arrivalDepartureRef.current.scrollIntoView({
          behavior: "smooth",
        })
      }
    }
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      if (this.state.accordionOpen) {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_open", { fold_title: this.props.block.heading })
      } else {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_close", { fold_title: this.props.block.heading })
      }
    })
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const infoboxTheme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.arrivalDepartureBackgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasContentBlocks = this.props.block.contentArea?.length > 0
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const scheduledTime = this.state.flightInfo.ScheduledTime
      ? DateTime.fromISO(this.state.flightInfo.ScheduledTime).setLocale(dtLocale).setZone(zone)
      : ""
    const estimatedPublicTime = this.state.flightInfo.EstimatedPublicTime
      ? DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
      : ""

    return (
      <div
        ref={this.arrivalDepartureRef}
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem foldable ${theme ? theme : ""}`}
      >
        <div className={"departure-info__essentials__detailitems__detailitem__header pointer"} onClick={(e) => this.handleAccordionClick(e)}>
          <div className="floatbox">
            <div>{this.state.flightInfo.EstimatedPublicTime ? estimatedPublicTime.toFormat("HH:mm") : this.state.awaitingClosedLabel}</div>
          </div>
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </div>
        <div className={"contentWrapper show-hide"}>
          <div className={`departure-info__essentials__detailitems__detailitem__infobox ${infoboxTheme}`}>
            <div className="grid">
              <div className="grid-item col--12">
                <div className="info-text">{this.props.block.arrivalDepartureTimeLabel}</div>
                <h5>
                  {this.state.flightInfo.EstimatedPublicTime ? (
                    <React.Fragment>
                      {estimatedPublicTime.toFormat("HH:mm")}
                      {scheduledTime < estimatedPublicTime ? (
                        <React.Fragment>
                          &ensp;<span className={"scheduled-time"}>{scheduledTime.toFormat("HH:mm")}</span>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  ) : (
                    this.state.awaitingClosedLabel
                  )}
                </h5>
              </div>
              {this.state.flightInfo.Direction === "A" ? (
                <div className="grid-item col--12">
                  <div className="info-text">{this.props.block.gateLabel ?? "Ankomst gate"}</div>
                  <h5 className={this.state.flightInfo.Gate ? "" : "awaiting"}>
                    {this.state.flightInfo.Gate ? this.state.flightInfo.Gate : this.state.awaitingClosedLabel}
                  </h5>
                </div>
              ) : (
                ""
              )}
              {/* <div className="grid-item col--12">
                                <div className="info-text" dangerouslySetInnerHTML={{ __html: this.props.block.nbText }}>
                                </div>
                            </div> */}
            </div>
          </div>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => this.handleClickTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {hasContentBlocks ? this.renderContentBlocks(this.state.block.contentArea) : ""}
        </div>
      </div>
    )
  }
}
